import { JobTipo, JobStatus, JobPerfil } from '../generated/backend-enums.js';
export { JobTipo, JobStatus, JobPerfil };
export const JobTipoMap = {
    [JobTipo.ATIVACAO]: 'Ativação',
    [JobTipo.BRINDES]: 'Brindes',
    [JobTipo.DIVERSOS]: 'Diversos',
    [JobTipo.EVENTO_FISICO]: 'Evento Físico',
    [JobTipo.FEE]: 'FEE',
    [JobTipo.INCENTIVO]: 'Incentivo',
    [JobTipo.MATERIAIS]: 'Materiais',
    [JobTipo.MPDV]: 'MPDV',
    [JobTipo.PROMOCAO]: 'Promoção',
    [JobTipo.TRIANGULACAO]: 'Triangulação',
};
export const JobStatusMap = {
    [JobStatus.EM_ANDAMENTO]: 'Em Andamento',
    [JobStatus.EM_BRIEFING]: 'Em Briefing',
    [JobStatus.EM_PROJETO]: 'Em Projeto',
    [JobStatus.ENCERRADO]: 'Encerrado',
};
export const JobPerfilMap = {
    [JobPerfil.ESTRATEGICO]: 'Estratégico',
    [JobPerfil.TATICO]: 'Tático',
    [JobPerfil.OPERACIONAL]: 'Operacional',
    [JobPerfil.INSTITUCIONAL]: 'Institucional',
};
